export const query_indicatori_anomalia_byFascicolo = `
query getIndicatoriByFascicolo($fascicoloId: Int!) {
  indicatore_anomalia(where: {FascicoloId: {_eq: $fascicoloId}}, order_by: {Date: desc}) {
    Id
    Date
    ProvidedBy
    Result
    Note
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
  }
}`;